// 消息推送
export default {
    time: 'time',
    startTime: 'start date',
    endTime: 'end date',
    to: 'to',
    userName: 'Account Name',
    roleName: 'Role Name',
    operate: 'operate',
    department: 'Department',
    personName: "account",
    role: 'role',
    select: 'please choose',
}
